import { render, staticRenderFns } from "./SampleDetail.vue?vue&type=template&id=26d90203"
import script from "./SampleDetail.vue?vue&type=script&lang=js"
export * from "./SampleDetail.vue?vue&type=script&lang=js"
import style0 from "./SampleDetail.vue?vue&type=style&index=0&id=26d90203&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports